import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=30fce9b7&scoped=true"
import script from "./leave.vue?vue&type=script&lang=js"
export * from "./leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fce9b7",
  null
  
)

export default component.exports